import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'counter-card',
    templateUrl: 'counter-card.component.html',
    standalone: true,
    imports: [CommonModule]
})

export class CounterCardComponent implements OnInit {
    @Input() value: number | string = 0;
    @Input() label: string = '';
    @Input() bgClass: string = 'bg-indigo-50';
    @Input() textClass: string = 'text-indigo-800';

    constructor() {}

    ngOnInit() { }
}
